// @flow
import {getCreator, postCreator, putCreator} from '../../http';
import environment from '../../environment';

import type {DeliveryMethodName, TaxInvoiceRequest} from '../../entities';
export type CustomerRequest = {
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  identificationNumber?: string,
  identificationType?: string,
  // prefixCountry?: string,
};

export type Location = {
  id?: string,
  address1: string,
  address2?: string,
  admin1: string,
  admin2?: string,
  admin3?: string,
  admin4?: string,
  admin5?: string,
  admin6?: string,
  admin7?: string,
  zipCode?: string,
  country?: string,
  description?: string,
  placeId?: string,
  lat?: string,
  lng?: string,
  description?: string,
  type?: 'shipping-address-geo',
};

export type CustomerAddress = {
  // admin1?: number,
  // admin2?: number,
  // admin3?: number,
  admin1?: string,
  admin2?: string,
  admin3?: string,
  address1: string,
  address2?: string,
  address3?: string,
  address4?: string,
  address5?: string,
  address6?: string,
  address7?: string,
  zipCode?: string,
  country?: string,
  description?: string,
  lat?: string,
  longitud?: string,
  placeId?: string,
  provider?: string,
  zipCode?: string,
  country: string,
  location?: Location,
};

export type ItemRequest = {
  productId: string,
  productVariantId?: string,
  quantity: number,
  comment?: string,
};

export type CheckoutRequest = {
  orderData?: {
    // currency?: string,
    customer?: CustomerRequest,
    // paymentMethod?: PaymentMethod,
    items: ItemRequest[],
  },
  deliveryData?: {
    deliveryMethod: DeliveryMethodName,
    pickupData?: {
      pickupAddressId?: string,
    },
    shippingData?: {
      shippingAddress: CustomerAddress,
      shippingAddressType?: string,
      flatRateId?: string,
    },
  },
  paymentData?: {
    storePaymentMethodProcessorId: string,
    billingAddress?: CustomerAddress,
    useShippingAsBilling?: boolean,
  },
  orderTaxInvoiceInformationData?: TaxInvoiceRequest,
};

export const endpoints = Object.freeze({
  GET_SHOPPING_CART_PRICES: `${environment.baseApiUrl}/im/admin/shopping-cart/summary`,
  GET_ORDER_SUMMARY: `${environment.baseApiUrl}/im/admin/order/summary`,
  CREATE_ORDER: `${environment.baseApiUrl}/im/admin/order`,
  EDIT_ORDER: `${environment.baseApiUrl}/im/admin/order/:orderId`,
  CREATE_PRE_ORDER: `${environment.baseApiUrl}/im/admin/pre-order`,
  EDIT_PRE_ORDER: `${environment.baseApiUrl}/im/admin/pre-order/:orderId`,

  EDIT_TAX_INVOICE_DATA: `${environment.baseApiUrl}/im/admin/order/:orderId/tax-invoice`,

  GET_DELIVERY_METHODS: `${environment.baseApiUrl}/im/delivery/method`,
});

export const getShoppingCartPricesApi = postCreator(
  endpoints.GET_SHOPPING_CART_PRICES
);
export const getOrderSummaryApi = postCreator(endpoints.GET_ORDER_SUMMARY);
export const createOrderApi = postCreator(endpoints.CREATE_ORDER);
export const editOrderApi = putCreator(endpoints.EDIT_ORDER);
export const createPreOrderApi = postCreator(endpoints.CREATE_PRE_ORDER);
export const editPreOrderApi = putCreator(endpoints.EDIT_PRE_ORDER);
export const editTaxInvoiceDataApi = putCreator(
  endpoints.EDIT_TAX_INVOICE_DATA
);

export const getDeliveryMethodsApi = getCreator(endpoints.GET_DELIVERY_METHODS);
